import { BehaviorSubject } from 'rxjs';

export abstract class AbstractDiscussionFacade {

    public abstract _entityId: string;
    public abstract _pageId: string;
    public abstract _setLoadSubject: BehaviorSubject<boolean>;    
}